import firebase from "../../Config/fbConfig";
import Manager from "./Manager";


export const createShop = (shop, branches, files, completion) => {
    firebase.firestore().collection("shops").add(shop).then(res => {
        Manager.uploadImages(firebase.storage().ref("shops").child(res.id), ["logo", "background"], files, 0, {}, refs => {
            firebase.firestore().collection("shops").doc(res.id).update(refs).then(result => {
                for(let i=0;i< branches.length;i++){
                    firebase.firestore().collection("shops").doc(res.id).collection("branches").add(branches[i]);
                    if(i == branches.length-1){
                        completion(true);
                    }
                }
            }).catch(function (error) {
                completion(null);
            });
        })
    }).catch(function (error) {
        completion(null);
    });
};

export const updateGeneral = (id, shop, files, completion) => {
    let childs = [];
    let images = [];
    if(files.logo){
        childs.push("logo");
        images.push(files.logo);
    }
    if(files.background){
        childs.push("background");
        images.push(files.background);
    }
    firebase.firestore().collection("shops").doc(id).update(shop).then(res => {
        Manager.uploadImages(firebase.storage().ref("shops").child(id), childs, images, 0, {}, refs => {
            firebase.firestore().collection("shops").doc(id).update(refs).then(result => {
                completion(result);
            }).catch(function (error) {
                completion(null);
            });
        })
    }).catch(function (error) {
        completion(null);
    });
};

export const updateWorkingHours = (id, hours, completion) => {
    firebase.firestore().collection("shops").doc(id).update({ working_hours: hours}).then(res => {
        completion(res);
    }).catch(function (error) {
        completion(null);
    });
};

export const updateContacts = (id, contacts, completion) => {
    firebase.firestore().collection("shops").doc(id).update(contacts).then(res => {
        completion(res);
    }).catch(function (error) {
        completion(null);
    });
};

export const updateMedia = (id, media, completion) => {
    firebase.firestore().collection("shops").doc(id).update(media).then(res => {
        completion(res);
    }).catch(function (error) {
        completion(null);
    });
};

export const addBranch = (id, branch, completion) => {
    firebase.firestore().collection("shops").doc(id).collection("branches").add(branch).then(res => {
        completion(res);
    }).catch(function (error) {
        completion(null);
    });
};

export const updateImage = (id, type, file, completion) => {
    firebase.storage().ref("shops").child(id).child(type).put(file).then(res => {
        firebase.storage().ref("shops").child(id).child(type).getDownloadURL().then(url => {
            firebase.firestore().collection("shops").doc(id).update({ [type]: url}).then(res => {
                completion(res);
            }).catch(function (error) {
                completion(null);
            });
        });
    });
};


export const createReply = (id, reviewId, reply, completion) => {
    firebase.firestore().collection("shops").doc(id).collection("reviews").doc(reviewId).update({ reply: {
            body: reply,
            date: new Date()
    }}).then(res => {
        completion(res);
    }).catch(function (error) {
        completion(null);
    });
};


export const addMember = (id, uid, member, completion) => {
    firebase.firestore().collection("shops").doc(id).collection("team").doc(uid).set(member).then(res => {
        completion(res);
    }).catch(function (error) {
        completion(null);
    });
};

export const deleteMember = (id, uid, completion) => {
    firebase.firestore().collection("shops").doc(id).collection("team").doc(uid).delete().then(res => {
        completion(res);
    }).catch(function (error) {
        completion(null);
    });
};



// WEBPACK FOOTER //
// ./src/Store/Actions/shop.js